import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import Toggle from './../Toggle';
import Disclaimer from '../Disclaimer';
import { view12ImageOptions } from './views/view12'

class CockpitTable extends Component {
    constructor(props) {
		super(props);
		this.handleCockpitTableChange = this.handleCockpitTableChange.bind(this);
    }

	handleCockpitTableChange(event) {
		let configuration = this.props.configuration;
		configuration.CockpitTable = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}
    render() {
		let imageOptions = view12ImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>

					<h1><Trans defaults='Cockpit Table' /></h1>

					<Toggle checked={this.props.configuration.CockpitTable.value === 2} onChange={this.handleCockpitTableChange}>
						<Trans defaults='Demountable cockpit table' />
					</Toggle>

                    <Disclaimer />
                   

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(CockpitTable);



// WEBPACK FOOTER //
// ./src/X43MK2/CockpitTable.js